import { profile } from '@/Utils/profile';

const iesResilienceEval = profile.get('iesResilienceEval') === 'true';
const ieslabWeatherData = profile.get('ieslabWeatherData') === 'true';
const ieslabPhotovoltaicSys = profile.get('ieslabPhotovoltaicSys') === 'true';
const ieslabWindPowerGenerator = profile.get('ieslabWindPowerGenerator') === 'true';
const ieslabGasTurbine = profile.get('ieslabGasTurbine') === 'true';
const ieslabHeatPump = profile.get('ieslabHeatPump') === 'true';
const ieslabGasBoiler = profile.get('ieslabGasBoiler') === 'true';
const ieslabHPSolarCollector = profile.get('ieslabHPSolarCollector') === 'true';
const ieslabCompRefrg = profile.get('ieslabCompRefrg') === 'true';
const ieslabAbsorptionChiller = profile.get('ieslabAbsorptionChiller') === 'true';
const ieslabBattery = profile.get('ieslabBattery') === 'true';
const ieslabWaterTank = profile.get('ieslabWaterTank') === 'true';
const ieslabIceStorageAC = profile.get('ieslabIceStorageAC') === 'true';
const ieslabTransformer = profile.get('ieslabTransformer') === 'true';
const ieslabTransferLine = profile.get('ieslabTransferLine') === 'true';
const ieslabMMC = profile.get('ieslabMMC') === 'true';
const ieslabCentrifugalPump = profile.get('ieslabCentrifugalPump') === 'true';
const ieslabPipe = profile.get('ieslabPipe') === 'true';
const ieslabThermalLoads = profile.get('ieslabThermalLoads') === 'true';
const ieslabPowerLoad = profile.get('ieslabPowerLoad') === 'true';
const ieslabFuel = profile.get('ieslabFuel') === 'true';
const ieslabHVACHeating = profile.get('ieslabHVACHeating') === 'true';
const ieslabHVACCooling = profile.get('ieslabHVACCooling') === 'true';
const ieslabConstPower = profile.get('ieslabConstPower') === 'true';
const ieslabTimeSharing = profile.get('ieslabTimeSharing') === 'true';
const ieslabLadderElectricity = profile.get('ieslabLadderElectricity') === 'true';
const ieslabLadderTime = profile.get('ieslabLadderTime') === 'true';

export {
    iesResilienceEval,
    ieslabWeatherData,
    ieslabPhotovoltaicSys,
    ieslabWindPowerGenerator,
    ieslabGasTurbine,
    ieslabHeatPump,
    ieslabGasBoiler,
    ieslabHPSolarCollector,
    ieslabCompRefrg,
    ieslabAbsorptionChiller,
    ieslabBattery,
    ieslabWaterTank,
    ieslabIceStorageAC,
    ieslabTransformer,
    ieslabTransferLine,
    ieslabMMC,
    ieslabCentrifugalPump,
    ieslabPipe,
    ieslabThermalLoads,
    ieslabPowerLoad,
    ieslabFuel,
    ieslabHVACHeating,
    ieslabHVACCooling,
    ieslabConstPower,
    ieslabTimeSharing,
    ieslabLadderElectricity,
    ieslabLadderTime,
};
